import React, { useState } from "react";

import '@hassanmojab/react-modern-calendar-datepicker/lib/DatePicker.css';
import { Calendar } from '@hassanmojab/react-modern-calendar-datepicker';
import "./HourlyAndDailyLeaves.scss"
import moment from 'jalali-moment'
import LoginInDialog from "../Login/LoginInDialog";
import Axios from "middleware/axiosInstance";

const NewDailyLeave = () => {

    // check if authentication is expired
    const [authenticationIsExpired, setAuthenticationIsExpired] = useState(false);

    const [LeaveDaysRange, setLeaveDaysRange] = useState({
        from: null,
        to: null
    });
    const [leaveReason, setLeaveReason] = useState("")

    const [inProcess, setInProcess] = useState(false)

    function CreateRandomLeaveNumber() {
        return Math.floor(Math.random() * 10000) + 20000;
    }

    const LeaveDaysRangeSelected = LeaveDaysRange.from !== null && LeaveDaysRange.to !== null


    const SubmitDailyLeave = async () => {

        // check internet connection
        if (!navigator.onLine) {
            alert("به اینترنت متصل نمی باشید")
        }

        else {

            setInProcess(true)

            try {

                var startDailyDate = await moment.from(`${LeaveDaysRange.from.year}/${LeaveDaysRange.from.month}/${LeaveDaysRange.from.day}`, 'fa', 'YYYY/M/D').format('YYYY-MM-DD')
                // startDailyDate = 1400/12/02 00:00:00
                startDailyDate = `${startDailyDate} 00:00:00`

                var endDailyDate = await moment.from(`${LeaveDaysRange.to.year}/${LeaveDaysRange.to.month}/${LeaveDaysRange.to.day}`, 'fa', 'YYYY/M/D').format('YYYY-MM-DD')
                //  endDailyDate = 1400/12/02 23:59:59
                endDailyDate = `${endDailyDate} 23:59:59`

                const LeaveNumber = await CreateRandomLeaveNumber()

                const DailyLeaveTemplate = {
                    "api_token": `${localStorage.getItem("token")}`,
                    "number": `${LeaveNumber}`,
                    "from": `${startDailyDate}`,
                    "to": `${endDailyDate}`,
                    "leave_reason": `${leaveReason}`
                }
                const apiRoute = "leave"
                Axios.post(apiRoute, DailyLeaveTemplate,
                )
                    .then((response) => {
                        alert("مرخصی شما با موفقیت ثبت شد")
                    })
                    .catch((error) => {
                        error.response.data.message === "Unauthenticated." ? setAuthenticationIsExpired(true) :
                            alert("متاسفانه مرخصی شما ثبت نشد")
                    })
            }
            catch {
                alert("مشکلی پیش آمده جهت اطمینان لطفا از سامانه خارج شده و مجددا وارد شوید!")
            }
            finally {
                setInProcess(false)
            }
        }
    }


    return (
        <div className="main-leave-container">
            <div className="leave-inputs-container">
                <Calendar
                    value={LeaveDaysRange}
                    onChange={setLeaveDaysRange}
                    shouldHighlightWeekends
                    locale="fa"
                    style={{
                        height: '30px',
                        width: '150px',
                    }}
                    calendarClassName="responsive-calendar" />
            </div>

            <div className="leaves-reason-container">
                <div>
                    <textarea onBlur={e => setLeaveReason(e.target.value)}
                        style={{ "padding": "3px" }}
                        placeholder="در صورت تمایل می توانید توضیحات خود را در رابطه با مرخصی در این قسمت وارد نمایید!"
                        id="" cols="35" rows="5" maxLength="150" />
                </div>
            </div>

            <div className="daily-leave-inputs-confirm">
                {LeaveDaysRange.from ? `
                     از تاریخ
                                          ${LeaveDaysRange.from.year}/${LeaveDaysRange.from.month}/${LeaveDaysRange.from.day} `
                    : null
                }
                {LeaveDaysRange.to ? `
تا پایان روز
         ${LeaveDaysRange.to.year}/${LeaveDaysRange.to.month}/${LeaveDaysRange.to.day}`
                    : null
                }
            </div>

            <div className="leave-button-container">
                <button
                    onClick={SubmitDailyLeave}
                    disabled={inProcess || !LeaveDaysRangeSelected}

                    // variant="contained"
                    // color={LeaveDaysRangeSelected ? inProcess ? `secondary` : `success` : `error`}
                    className={LeaveDaysRangeSelected ? inProcess ? `custom-button-disable` : `custom-button-green` : `custom-button-disable`}
                >
                    {LeaveDaysRangeSelected ?
                        inProcess ?
                            `درحال ارسال درخواست ... ` :
                            `ثبت مرخصی`
                        : `ابتدا تاریخ را مشخص فرمایید`}
                </button>
            </div>
            {authenticationIsExpired && < LoginInDialog />}

        </div>
    );
};

export default NewDailyLeave;